import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { fetchProfile } from '../actions/profile';
import Avatar from './Avatar';
import svgSprite from '../styles/img/sprite.svg';

const Header = ({ user, onColorSelected }) => (
  <header className="header">
    <div className="user-location">
      <svg className="user-location__icon">
        <use xlinkHref={`${svgSprite}#icon-location-pin`} />
      </svg>
      <span className="user-location__name">
        {user && user.locations ? user.locations.name : 'Indonesia'}
      </span>
    </div>
    <div className="panel-settings">
      <span className="tiles tiles-grey" role="button" onClick={() => onColorSelected('#f0eeee')} aria-hidden />
      <span className="tiles tiles-blue" role="button" onClick={() => onColorSelected('#4d7cff')} aria-hidden />
      <span className="tiles tiles-green" role="button" onClick={() => onColorSelected('#0acf97')} aria-hidden />
      <span className="tiles tiles-orange" role="button" onClick={() => onColorSelected('#f5a623')} aria-hidden />
    </div>
    <nav className="user-nav">
      <div className="user-nav__user">
        <Avatar fullname={`${user.first_name} ${user.last_name}`} margin={5} />
        <span className="user-nav__user-name">
          {user && `${user.first_name}  ${user.last_name}`}
        </span>
        <ul className="dropdown">
          <li className="dropdown__item">
            <Link to="/logout" className="dropdown__item-link">
              <svg className="dropdown__item-icon">
                <use xlinkHref={`${svgSprite}#icon-log-out`} />
              </svg>
              <span className="dropdown__item-name">
                Log out
              </span>
            </Link>
          </li>
        </ul>
      </div>
    </nav>
  </header>
);

Header.propTypes = {
  user: PropTypes.shape({
    locations: PropTypes.shape({
      name: PropTypes.string,
    }),
    first_name: PropTypes.string,
    last_name: PropTypes.string,
  }).isRequired,
  onColorSelected: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  user: state.profile,
});

const mapDispatchToProps = dispatch => ({
  fetchingUser: dispatch(fetchProfile()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Header);
